import script from "./UserCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCenter.vue?vue&type=script&setup=true&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=619e34eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619e34eb"]])

export default __exports__